var map = {
	"./01.png": 5220,
	"./02.png": 9492,
	"./03.png": 1174,
	"./04.png": 7131,
	"./05.png": 5904,
	"./06.png": 9519,
	"./07.png": 3803,
	"./08.png": 1827,
	"./09.png": 2355,
	"./10.png": 989,
	"./11.png": 7025,
	"./12.png": 5592,
	"./13.png": 9019,
	"./14.png": 5325,
	"./15.png": 6921,
	"./coin.png": 6336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5409;